import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CostPlanStateService } from './service/cost-plan-state.service';
import { ModuleRegistry } from 'ag-grid-community';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false // NOSONAR
})
export class AppComponent {
	isAuthorized: boolean = false;
	AUthToken: boolean = false;
	clientHeight: number;

	constructor(private readonly state: CostPlanStateService) {
		console.info('Prod environment:' + environment.production)     // Logs false for all other environments
		this.clientHeight = window.innerHeight;
	}
	title = 'LIOS Cost Planning';

	ngOnInit() { // NOSONAR
		if (localStorage.getItem('toyotaGUID')) {
			this.AUthToken = true;
		}

		
		this.state.roleState.subscribe((value) => {
			if (value) {
				this.isAuthorized = true;
			}
		});
		
	}
}
